import WithRender from "../../templates/buttons/personalizationButton.html";
import * as R from "ramda";
import { mapActions, mapGetters } from "vuex";
import Select2 from "v-select2-component";
import { i18n } from "../../i18n.js";

export default WithRender({
  components: { Select2 },
  computed: {
    ...mapGetters([
      "getPersonalizeLoading",
      "getConfig",
      "getWebProductTemplate",
      "getIsPersonalizationNewPage",
      "getQuantity",
      "getCustomer",
      "getIsLogin",
      "getWebProductEnableTemplateChooser",
      "getWebProductEnableTemplates",
      "getSelectedTemplateId",
      "getCostCenter",
      "getHideSearchBoxInPoptext",
      "getCostCenterIsRequired",
      "getCostCenter",
      "getQuantityField",
      "getChangeOptionsData",
      "getTheme"
    ]),
    settings: function () {
      var hideOptions = {};
      if (this.getHideSearchBoxInPoptext) {
        hideOptions = { minimumResultsForSearch: -1 };
      }
      return { ...hideOptions };
    },
    getDisableClass: function () {
      return this.getPersonalizeLoading ? "disable" : "";
    },
    options: function () {
      return this.getWebProductEnableTemplates;
    },
    value: {
      get: function () {
        return this.getSelectedTemplateId;
      },
      set: function (newValue) {
        this.setSelectedTemplateId(newValue);
      }
    }
  },
  methods: {
    ...mapActions(["getPersonalizeUrl", "setSelectedTemplateId"]),
    onClickPersonalize: function () {
      if (this.getCostCenterIsRequired && !this.getCostCenter) {
        this.$swal({
          text: i18n.t("Please enter cost center number !"),
          icon: "warning"
        });
        return;
      }
      const formEl = $(this.$refs.personalizeBtn).closest("form");
      const formParams = formEl.serializeArray();

      const params = R.reduce(
        (acc, param) => {
          if (
            [
              "customizedProductId",
              "customizedProductIdSaveFrame",
              "templateId",
              "pq_type"
            ].indexOf(param.name) !== -1
          ) {
            return acc;
          }
          acc[param.name] = param.value;
          return acc;
        },
        {},
        formParams
      );

      const isPersonalizationNewPage = this.getIsPersonalizationNewPage;

      params.template_id = this.getWebProductTemplate;
      params.isPersonalizationNewPage = isPersonalizationNewPage;
      params.locale = this.$i18n.locale;
      params.personalizationQty = this.getQuantity;
      params.qty = this.getQuantity;
      params.customer = this.getCustomer;
      params.isLogin = this.getIsLogin;
      params.cost_center_number = this.getCostCenter;
      if (this.getTheme) {
        params.theme = this.getTheme;
      }

      const toggleBodyScroll = function (status) {
        if (document.body.parentElement) {
          if (!status) document.body.parentElement.style.overflow = "hidden";
          else document.body.parentElement.style.overflow = "";
        }
      };

      this.getPersonalizeUrl({
        wnd: this,
        params: params,
        personalizationCB: url => {
          if (isPersonalizationNewPage) {
            window.location.href = url;
          } else {
            window.fancyboxInstance = $.fancybox.open({
              src: url,
              type: "iframe",
              width: "100%",
              height: "100%",
              iframe: {
                preload: true,
                css: {
                  width: "100%",
                  height: "100%",
                  "max-width": "100%",
                  "max-height": "100%"
                }
              },
              opts: {
                iframe: {
                  preload: true,
                  css: {
                    width: "100%",
                    height: "100%",
                    "max-width": "100%",
                    "max-height": "100%"
                  }
                },
                afterShow: function (instance, current) {
                  toggleBodyScroll(false);
                },
                afterClose: function (instance, current) {
                  toggleBodyScroll(true);
                }
              }
            });
          }
        }
      });
    }
  }
});
